import { Carousel, Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import { chunk } from "lodash";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import classes from "./styles.module.scss";
import { LogoCard, Title, Description } from "@/ui";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@react-hook/media-query";

export default function LogoCarousel({
  sectionId,
  className,
  bgColor,
  title,
  titleColor,
  description,
  items,
  visibleCount: desktopVisibleCount,
  link,
}) {
  const [visibleCount, setVisibleCount] = useState(1);
  const xl = useMediaQuery("only screen and (min-width: 1200px)");
  const lg = useMediaQuery("only screen and (min-width: 992px)");
  const md = useMediaQuery("only screen and (min-width: 768px)");

  useEffect(() => {
    setVisibleCount(xl ? desktopVisibleCount : lg ? 3 : md ? 2 : 1);
  }, [xl, lg, md, desktopVisibleCount]);

  if (items.length === 0) return null;

  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.logos)}>
      <Container className="mw-xxl">
        <Title className={titleColor} title={title} />
        <Description description={description} />
        <Carousel
          className={classes.logos__carousel}
          controls={true}
          prevIcon={<ChevronLeft width="14" height="25" />}
          nextIcon={<ChevronRight width="14" height="25" />}
        >
          {chunk(items, visibleCount).map((items, k) => (
            <Carousel.Item key={k}>
              <Row>
                {items.map(({ img, title, alt, href }, k) => (
                  <Col key={k} className="py-3">
                    <LogoCard logo={img?.url} name={title ?? alt} alt={alt} href={href} />
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>

        {link?.href && link?.label && (
          <div className="text-end mt-3">
            <a
              href={link.href}
              className="text-primary text-decoration-none fw-semibold d-inline-flex align-items-center"
            >
              {link.label} <ChevronRight className="ms-2" width="12" height="12" />
            </a>
          </div>
        )}
      </Container>
    </div>
  );
}